import React, { useState, useEffect } from "react";
import home_background1 from "../../Assets/Images/car1.jpg";
import home_background2 from "../../Assets/Images/car2.jpg";
import home_background3 from "../../Assets/Images/car3.jpg";
import home_background4 from "../../Assets/Images/car4.jpg";
import home_background5 from "../../Assets/Images/car5.jpg";
import home_background6 from "../../Assets/Images/car6.jpg";
import "./style.css";
import OurServices from "../../Components/Home/OurServices/OurServices";
import MissionStatement from "../../Components/Home/MissionStatement/MissionStatement";
import UpcomingEvents from "../../Components/Home/UpcomingEvents/UpcomingEvents";
import SEO from "../../Components/SEO";

import { useNavigate } from "react-router-dom";

const Home = () => {
  const navigate = useNavigate();
  const images = [
    home_background1,
    home_background2,
    home_background3,
    home_background4,
    home_background5,
    home_background6,
  ];
  const [index, setIndex] = useState(0);
  const user = JSON.parse(localStorage.getItem("user"));
  const self_pay = user?.is_self_pay !== undefined ? user?.is_self_pay : true;
  console.log("self_pay", self_pay);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000);

    return () => clearInterval(interval); // Cleanup on unmount
  }, [images.length]);
  return (
    <>
      <div className="home-container">
        {/* <div
          className="home-banner"
          style={{ backgroundImage: `url(${images[index]})` }}
        >
          <div className="home-left-banner">
            <h1>
              Unlock Your True Potential with <span>Judgment-Free</span> Sports
            </h1>
            <p>
              From beginners to advanced players, we foster growth in a
              supportive, judgment-free environment.
            </p>
            <button onClick={() => navigate("/buy-packages")}>
              View All Packages
            </button>
          </div>
        </div> */}
        <SEO
          title="BWC Sports | Quality Sports Services"
          description="Unlock Your True Potential with Judgment-Free Sports. From beginners to advanced players, we foster growth in a supportive, judgment-free environment."
          url="https://bwcsports.com/"
        />

        <div
          className="home-banner-overlay"
          style={{
            backgroundImage: `url(${images[index]})`,
            filter: "brightness(0.8)",
          }}
        >
          <div className="home-banner-cnt">
            <div className="home-left-col">
              <h1>
                <span className="black-text-clip">
                  Unlock Your True Potential with
                </span>{" "}
                <span
                  style={{
                    color: "transparent",
                    background: "linear-gradient(#c48308, #c48308)",
                    WebkitBackgroundClip: "text",
                    backgroundClip: "text",
                  }}
                >
                  Judgment-Free {" "}
                </span>
                <span className="black-text-clip">Sports</span>
              </h1>
              <p className="black-text-clip">
                From beginners to advanced players, we foster growth in a
                supportive, judgment-free environment.
              </p>
              {self_pay === true ? (
                <button onClick={() => navigate("/buy-packages")}>
                  View All Packages
                </button>
              ) : (
                <button onClick={() => navigate("/view-all-sessions")}>
                  View All Sessions
                </button>
              )}
            </div>
            <div className="home-right-col">
              <div
                className="home-right-sm-bg"
                style={{ backgroundImage: `url(${images[index]})` }}
              ></div>
            </div>
          </div>
        </div>

        <OurServices />
        <MissionStatement />
        <div id="upcoming-events">
          <UpcomingEvents />
        </div>
      </div>
    </>
  );
};
export default Home;
